import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  rightSlot?: ReactNode;
}

export function SectionHeader({ title, subtitle, rightSlot }: SectionHeaderProps) {
  return (
    <header className="flex flex-col items-stretch justify-between gap-3 sm:flex-row sm:items-end">
      <div className="min-w-0">
        <h3 className="text-[18px] font-semibold tracking-tight text-text-1">{title}</h3>
        {subtitle && <p className="text-[12px] text-text-3">{subtitle}</p>}
      </div>
      {rightSlot && <div className="min-w-0 sm:shrink-0">{rightSlot}</div>}
    </header>
  );
}
